import Swiper, { Navigation, Pagination, Thumbs, Scrollbar } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-product-gallery-image-carousel]',
};

class ProductGallery extends HTMLElement {
  constructor() {
    super();

    this.carouselWrappers = document.querySelectorAll(
      selectors.carouselWrapper
    );

    document.addEventListener('DOMContentLoaded', () => {
      this.breakpoint = window.matchMedia('(max-width:1023px)');

      // Init the carousel on load.
      this.initCarousel();

      // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
      // If not, it will get destroyed.
      this.registerEventListeners();
    });
  }

  initCarousel() {
    this.galleryCarousel = new Swiper(selectors.carouselWrapper, {
      modules: [Navigation, Pagination, Thumbs, Scrollbar],
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        1024: {
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: false,
          scrollbar: {
            el: '.slider-scrollbar',
            draggable: true,
            hide: false,
            snapOnRelease: false,
            dragSize: 240,
          },
        },
      },
    });
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.initCarousel();
    });
  }
}

customElements.define('product-gallery', ProductGallery);
